import icons from '../../../../../world/spa/libs/icons';

const getWorldIcon = icons.getWorldIcon;

export default {
    namespaced: true,
    state: {
        indexHref: '/',
        appName: 'ANM22 Tasks',
        appColor: '#88ed7c',
    },
    getters: {
        HBTheme: state => {
            return {
                appImg: getWorldIcon('taskIcon'),
                appName: 'ANM22 Tasks',
                appNameColor: "#88ed7c"
            }
        },
        getMapsKey: state => {
            return state.mapsAPIKey;
        }
    },
    mutations: {
    },
    actions: {
    }
}